<template>
    <svg
        class="sps-header-icon"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <circle cx="10" cy="4.6" r="1.6" :fill="color || 'currentColor'" />
        <circle cx="10" cy="10" r="1.6" :fill="color || 'currentColor'" />
        <circle cx="10" cy="15.4" r="1.6" :fill="color || 'currentColor'" />
    </svg>
</template>
<script>
export default {
    name: "MoreIcon",
    props: ["color"],
};
</script>
<style scoped>
.sps-header-icon {
    display: block;
    color: var(--header-text-color);
}
</style>



// WEBPACK FOOTER //
// src/components/V2/svg/components/MoreIcon.vue